export const getWindowDimension = (): { width: number; height: number } => ({
  width: window.innerWidth,
  height: window.innerHeight,
});

export type DeviceType = "iOS" | "Android" | "Desktop";
export const getDeviceType = (): DeviceType => {
  const userAgent = navigator.userAgent;

  if (/iPad|iPhone|iPod/.test(userAgent)) {
    return "iOS";
  } else if (/Android/.test(userAgent)) {
    return "Android";
  }
  return "Desktop";
};

export type OsName =
  | "Windows"
  | "macOS"
  | "Linux"
  | "iOS"
  | "Android"
  | "Unknown";
export const getOSName = (): OsName => {
  const userAgent = navigator.userAgent;

  if (/Windows/.test(userAgent)) {
    return "Windows";
  } else if (/Macintosh/.test(userAgent)) {
    return "macOS";
  } else if (/Linux/.test(userAgent)) {
    return "Linux";
  } else if (/iPhone|iPad|iPod/.test(userAgent)) {
    return "iOS";
  } else if (/Android/.test(userAgent)) {
    return "Android";
  } else {
    return "Unknown";
  }
};

export const getOSVersion = (): string => {
  const userAgent = navigator.userAgent;

  if (/Windows/.test(userAgent)) {
    return userAgent.match(/Windows NT (\d+\.\d+)/)?.[1] ?? "";
  } else if (/Macintosh/.test(userAgent)) {
    return (
      userAgent
        .match(/Mac OS X (\d+[_.]\d+[_.]?\d*)/)?.[1]
        ?.replace(/_/g, ".") ?? ""
    );
  } else if (/iPhone|iPad|iPod/.test(userAgent)) {
    return (
      userAgent.match(/OS (\d+[_.]\d+[_.]?\d*)/)?.[1]?.replace(/_/g, ".") ?? ""
    );
  } else if (/Android/.test(userAgent)) {
    return userAgent.match(/Android (\d+[_.]\d+[_.]?\d*)/)?.[1] ?? "";
  }
  return "";
};

export type BrowserName =
  | "Chrome"
  | "Firefox"
  | "Safari"
  | "Microsoft Edge"
  | "Internet Explorer"
  | "Unknown";
export const getBrowserName = (): BrowserName => {
  const userAgent = navigator.userAgent;
  if (/Chrome/.test(userAgent)) {
    return "Chrome";
  } else if (/Firefox/.test(userAgent)) {
    return "Firefox";
  } else if (/Safari/.test(userAgent)) {
    return "Safari";
  } else if (/Edge/.test(userAgent)) {
    return "Microsoft Edge";
  } else if (/Trident/.test(userAgent)) {
    return "Internet Explorer";
  } else {
    return "Unknown";
  }
};

export const getBrowserVersion = (): string => {
  const userAgent = navigator.userAgent;

  if (/Chrome/.test(userAgent)) {
    return userAgent.match(/Chrome\/(\d+)/)?.[1] ?? "";
  } else if (/Firefox/.test(userAgent)) {
    return userAgent.match(/Firefox\/(\d+)/)?.[1] ?? "";
  } else if (/Safari/.test(userAgent)) {
    return userAgent.match(/Version\/(\d+)/)?.[1] ?? "";
  } else if (/Edge/.test(userAgent)) {
    return userAgent.match(/Edge\/(\d+)/)?.[1] ?? "";
  } else if (/Trident/.test(userAgent)) {
    return userAgent.match(/rv:(\d+)/)?.[1] ?? "";
  }
  return "";
};
